import React, { useEffect, useState } from 'react';
import { Canvas, IText } from 'fabric';
import { AlignCenter, AlignLeft, AlignRight } from 'lucide-react';
import { ToolBtn } from '../../../shared/ui/tool-btn';
import { usePieceDispatch } from '../../../model/piece-context';
import { useSelectedLayer, useSelectedLayerId } from '../../../selection/hooks/use-selected-layer';
import type { TextAlign } from '../../../shared/types/text-align';
import { TEXT_DEFAULTS } from '../../constants/text-defaults';

interface AlignControlsProps {
  textObject: IText;
  canvas: Canvas;
}

// Shared by plain text and sobreimpreso.
export const AlignControls: React.FC<AlignControlsProps> = ({ textObject, canvas }) => {
  const dispatch = usePieceDispatch();
  const layerId = useSelectedLayerId();
  const layer = useSelectedLayer();
  const [textAlign, setTextAlign] = useState<TextAlign>('left');

  useEffect(() => {
    if (layer?.kind !== 'text' && layer?.kind !== 'sobreimpreso') return;
    setTextAlign(layer.content.textAlign ?? TEXT_DEFAULTS.textAlign);
  }, [layer]);

  const apply = (value: TextAlign) => {
    setTextAlign(value);
    textObject.set({ textAlign: value }); // preview
    canvas.requestRenderAll();
    if (layerId) dispatch({ type: 'patchLayerContent', id: layerId, patch: { textAlign: value } });
  };

  return (
    <>
      <ToolBtn onClick={() => apply('left')} title='Alinear izquierda' active={textAlign === 'left'}>
        <AlignLeft size={15} />
      </ToolBtn>
      <ToolBtn onClick={() => apply('center')} title='Centrar' active={textAlign === 'center'}>
        <AlignCenter size={15} />
      </ToolBtn>
      <ToolBtn onClick={() => apply('right')} title='Alinear derecha' active={textAlign === 'right'}>
        <AlignRight size={15} />
      </ToolBtn>
    </>
  );
};
